@use "../../../scss/variables" as *;
@use "../../../scss/format-template" as *;
@use "../../../scss/mixins" as *;

#skip-main-content-button {
    position: absolute;
    top: -100rem;
    left: 1rem;
    width: auto;
    height: auto;
    z-index: 9999;
    outline: 5px auto -webkit-focus-ring-color;
    background-color: $wf-white;
    color: $wf-gray-04;
    padding: 0.625rem;
    margin-bottom: 0.625rem;
    text-decoration: none;
    border-radius: 5px;

    &:focus {
        top: 1rem;
    }
}

:host {
    --vx-select-box-shadow: 0 3px 1px -8px rgb(0 0 0 / 20%),
        0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);

    /*** THEME VARIABLES ***/
    --mdc-theme-primary: #{$mdc-theme-primary};
    --mdc-shape-small: #{$mdc-shape-small};
    --mdc-shape-normal: #{$mdc-shape-normal};
    --mdc-shape-medium: #{$mdc-shape-medium};
    --mdc-shape-large: #{mdc-shape-large};
    --mdc-typography-font-family: #{$mdc-typography-font-family};
    --mdc-buton-primary-hover: #{mdc-buton-primary-hover};

    /*** WF VARIABLES ***/
    --wf-white: #{$wf-white};
    --wf-black: #{$wf-black};
    --wf-gray-01: #{$wf-gray-01};
    --wf-gray-02: #{$wf-gray-02};
    --wf-gray-04: #{$wf-gray-04};
    --wf-traubenrot-01: #{$wf-traubenrot-01};
    --wf-traubenrot-70: #{$wf-traubenrot-70};
    --wf-weingruen-01: #{$wf-weingruen-01};
    --wf-champagne-01: #{$wf-champagne-01};

    /*** TYPOGRAPHY ***/
    --wf-font-family: #{$wf-font-family};
    --wf-font-family-serif: #{$wf-font-family-serif};
    --wf-font-family-sans-serif: #{$wf-font-family-sans-serif};

    /*** PDS Specific ***/
    --bottle-space: -32px;
    --page-width: #{$page-width};
    --vx-collapse-toggle-font-family: #{$wf-font-family-sans-serif};
    --vx-back-button-background-color: #{$wf-white};
    --vx-tabs-content-font-family: #{$wf-tiempos-3-font-family}; // var(--wf-tiempos-3-font-family, serif);
    --vx-tabs-content-font-size--mobile: #{$wf-tiempos-3-font-size}; // var(--wf-tiempos-3-font-size, 1.25rem);
    --vx-tabs-content-font-weight: #{$wf-tiempos-3-font-weight}; // var(--wf-tiempos-3-font-weight, 400);
    --vx-tabs-content-line-height--mobile: #{$wf-tiempos-3-line-height}; // var(--wf-tiempos-3-line-height, 1.875rem);
    --vx-price-detail-font-size: #{$wf-caption-2-font-size};
    --vx-price-detail-font-weight: #{$wf-caption-2-font-weight};
    --vx-price-detail-line-height: #{$wf-caption-2-line-height};
    --vx-price-detail-text-color: #{$wf-caption-2-color};

    font-family: var(--wf-font-family-sans-serif, $wf-font-family-sans-serif);
    font-size: $base-font-size;
}

a {
    &:hover {
        color: var(--mdc-button-primary-hover, $wf-red) !important;
    }
}

p {
    margin: unset;
    box-sizing: border-box;
}

.container {
    display: flex;
    flex-direction: column;

    .grid-container {
        display: grid;
        grid-template-columns: auto;
    }

    .header {
        background-color: transparent;
        padding-top: 0;

        &.grid-container {
            margin: 0;
        }

        wf-badge {
            z-index: 2;
        }

        vx-back-button {
            z-index: 2;
            max-width: 140px;
            grid-column: 1 / 3;
            grid-row: 1 / 2;
            align-items: flex-start;
            background-color: var(--wf-gray-01, $wf-gray-01);
            padding-top: 16px;
            padding-left: 0.7562rem;
        }

        wf-awards {
            grid-column: 1 / 3;
            grid-row: 2 / 3;
            background-color: var(--wf-gray-01, $wf-gray-01);
            padding-left: 0.7562rem;
        }

        .product-image-container {
            display: grid;
            grid-column: 2 / 3;
            grid-row: 1 / 3;
            grid-template-columns: max-content;
            grid-template-rows: auto;
            justify-items: center;
            justify-content: center;
            padding-top: 16px;
            width: auto;
            z-index: 3;

            .alert--product-unavailable {
                z-index: 2;
                text-align: center;
                transform: translateY(30vh);
                color: var(--wf-color-danger, $wf-red);
                text-shadow: 0 0 5px white;
            }

            .product-image {
                width: auto;
                height: 340px;
                margin-bottom: var(--bottle-space);

                @media screen {
                    @media (min-width: 550px) {
                        height: 440px;
                    }

                    @media (min-width: 960px) {
                        height: 540px;
                    }
                }
            }
        }

        .badges {
            grid-column: 2 / 4;
            grid-row: 1 / 3;

            background-color: var(--wf-gray-01, $wf-gray-01);
            padding-right: 0.7562rem;

            justify-items: flex-end;
            padding-top: 16px;
        }

        .product-info {
            grid-column: 1 / 4;
            grid-row: 3 / 4;

            margin-top: calc(-1.5 * var(--bottle-space));
            padding-left: 0.7562rem;
            padding-right: 0.7562rem;

            .product-info__inner {
                display: grid;
                grid-template-columns: 1fr;
                grid-gap: 16px;

                .title {
                    h1 {
                        @include font-template("headline-1");
                        margin: 0;
                        padding: 0;
                    }
                }

                .supplier {
                    @include font-template("body-1");
                    color: currentcolor;
                }

                ul.details {
                    list-style: none;
                    padding: 0;
                    margin: 0;

                    display: flex;
                    flex-direction: row;
                    gap: 8px;
                }

                li.detail {
                    padding: 4px 8px;
                    border-radius: 8px;
                    user-select: none;
                    border: solid 1px var(--wf-gray-02, $wf-gray-02);
                    backdrop-filter: var(
                        --wf-product-tag-backdrop-filter,
                        invert(0.02)
                    );
                    display: flex;
                    align-items: center;
                    text-align: center;

                    @include font-template("button-filter");
                }

                .article-actions {
                    display: grid;
                    grid-template-columns: auto;
                    grid-gap: 12px;
                    align-items: center;
                }

                .shipping-info {
                    @include font-template("caption-3");
                }

                .title,
                .supplier {
                    grid-column: 1 / 2;
                }

                .details,
                wf-price,
                .article-actions,
                .shipping-info,
                vx-payback,
                wf-loyalty-points-price-info {
                    grid-column: 1 / 2;
                }

                .details,
                wf-price {
                    margin-top: 8px;
                }

                vx-wishlist {
                    position: absolute;
                    justify-self: end;
                    margin-top: -96px;
                    align-items: center;
                    right: 8px;
                }
            }
        }
    }

    .content {
        grid-column: 1 / 4;
        grid-row: 1 / 3;
        grid-template-columns: repeat(1, minmax(0, 1fr));

        display: grid;

        .product-description {
            display: grid;
            grid-column: 1 / 5;
            grid-row: 3;
            grid-template-columns: repeat(1, minmax(0, 1fr));
            box-sizing: border-box;

            max-width: var($page-width, --page-width);
            margin: calc(-1 * var(--bottle-space)) auto 0;

            padding: 16px;

            @media screen {
                @media (max-width: 599px) {
                    padding-top: 16px;
                    margin-top: 0;
                }
            }

            background-color: white;

            .bundle-information,
            .bundle-information > p {
                @include font-template("tiempos-1");
            }

            .bundle-information-notice {
                font-size: 0.875rem;
                color: var(--wf-gray-04, #908787);
                margin-bottom: 16px;
            }

            .teaser {
                @include font-template("tiempos-1");
            }

            .nutritional-header {
                font-size: 1rem;
                font-weight: bold;
            }
        }

        .product-teaser {
            grid-row: 1;
        }

        .manufacturer-cover {
            min-height: 300px;
            grid-column: 1 / -1;
        }

        .nutritional-header {
            font-size: 1rem;
            font-weight: bold;
        }
    }

    .recommendations-container {
        background-color: var(--wf-gray-01, $wf-gray-01);
        min-height: 750px; /* shift fix */

        p.recommendations-headline {
            font-size: x-large;
            font-weight: bold;
            padding-left: 0.7562rem;
            padding-right: 0.7562rem;
            padding-top: 2.5rem;
        }
    }

    &.product-unavailable {
        .product-image-container {
            vx-image {
                filter: opacity(30%);
            }
        }
    }
}

@media screen {
    @media (min-width: 600px) {
        :host {
            --vx-tabs-content-font-size--mobile: #{$wf-tiempos-3-font-size--desktop}; // var(--wf-tiempos-3-font-size, 1.25rem);
            --vx-tabs-content-line-height--mobile: #{$wf-tiempos-3-line-height--desktop}; // var(--wf-tiempos-3-line-height, 1.875rem);
            --vx-price-detail-font-size: #{$wf-caption-2-font-size--desktop};
            --vx-price-detail-line-height: #{$wf-caption-2-line-height--desktop};
        }

        .container {
            .grid-container {
                grid-template-columns: 100px 1fr 1fr 100px;
                grid-template-rows: repeat(2, auto);

                padding-left: 16px;
                padding-right: 16px;
            }

            .header {
                background-color: var(--wf-gray-01, $wf-gray-01);
                padding-top: 32px;

                wf-awards {
                    padding: 0;
                }

                vx-back-button {
                    max-width: 140px;
                    grid-column: 1 / 2;
                    grid-row: 1 / 2;
                    padding-left: 0;
                    padding-top: 0;
                    padding-bottom: 16px;
                }

                .product-image-container {
                    padding-right: 32px;
                    grid-column: 2 / 3;
                    grid-row: 2 / 3;
                    margin-bottom: var(--bottle-space);

                    padding-top: 0;
                }

                .badges {
                    grid-column: 2 / 3;
                    grid-row: 1 / 3;
                    justify-items: flex-end;
                    padding-top: 4px;
                }

                .product-info {
                    grid-column: 3 / 4;
                    grid-row: 1 / 3;
                    margin: 16px 0;
                    margin-top: -6px;
                    padding-left: 32px;
                    padding-right: 0;

                    .product-info__inner {
                        grid-template-columns: 3fr 1fr;
                        grid-template-rows: repeat(8, auto);

                        .title,
                        .supplier,
                        .details {
                            grid-column: 1 / 3;
                        }

                        li.detail {
                            padding: 8px 12px;
                        }

                        vx-wishlist {
                            grid-column: 2 / 3;
                            position: relative;
                            justify-self: unset;
                            margin-top: 0;
                        }
                    }
                }
            }

            .content {
                margin-top: calc(-4 * var(--bottle-space));
                padding: 0;

                grid-row-gap: 48px;

                .product-description {
                    grid-column: 2 / 4;
                    width: 100%;
                    margin: var(--bottle-space) auto 0;
                }
            }

            .recommendations-container {
                padding: 0 32px;
            }
        }
    }
}
